import { useEffect, useRef, useState } from 'react';

type Event = MouseEvent | TouchEvent;

const useDetectOutsideClick = <T extends HTMLElement>(
dropdownRef: any, initialState: boolean): [boolean, React.Dispatch<React.SetStateAction<boolean>>] => {
  const [isActive, setIsActive] = useState(initialState);
  const ref = useRef<T>(null);

  const handleClickOutside = (event: Event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setIsActive(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, []);

  return [isActive, setIsActive];
};

export default useDetectOutsideClick;